













































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import OtpLogin from '../ExternalUser/OtpLogin.vue';
import { HTTP_RESPONSE } from '@/services/Enums';
import ForgotPassword from '../ExternalUser/ForgotPassword.vue';
import ResetPassword from '../ExternalUser/ResetPassword.vue';

@Component({
    components: {
        OtpLogin,
        ForgotPassword,
        ResetPassword
    }
})
export default class Login extends Vue {
    username: string = '';
    password: string = '';
    loading: boolean = false;
    loginIsActive: boolean = true;
    parentMounted: boolean = false;

    resetPasswordToken: string = null;
    resetPasswordUsername: string = null;
    forgotPassword: boolean = false;
    resetPasswordModalTitle: string = null;
    currentClientVersion: string = null;
    
    mounted() {
        this.loginIsActive = !this.$store.state.isLogged;      
        this.currentClientVersion = this.$store.getters.checkClientVersion; 
        this.parentMounted = true;

        this.getResetPasswordRequest();
    }

    getResetPasswordRequest() {
        let urlParams = new URLSearchParams(window.location.search);
        
        if(urlParams.get('token') != null)
            this.resetPasswordToken = decodeURIComponent(urlParams.get('token'));
        if(urlParams.get('username') != null)
            this.resetPasswordUsername = decodeURIComponent(urlParams.get('username'));
        if(urlParams.get('forgotPassword') != null) {
            if(urlParams.get('forgotPassword').toLowerCase() === 'true')
                this.forgotPassword = true;
        }

        if (this.resetPasswordToken != null && this.resetPasswordUsername != null) {
            if(this.forgotPassword == true)
                this.resetPasswordModalTitle = "Reset Password - ";
            else
                this.resetPasswordModalTitle = "ePli | Set New Password - ";

            this.resetPasswordModalTitle += this.resetPasswordUsername;

            this.$bvModal.show('resetPasswordModal');
        }
    }

    getMessage(data: any) {        
        switch (data.response) {
            case HTTP_RESPONSE.LoginFailed:
                let msg = 'Login failed';
                if (data.message != null && data.message != "") msg = msg + " - " + data.message;
                return msg;
            case HTTP_RESPONSE.UserDoesntExist:
                return 'User doesn\'t exist';
            case HTTP_RESPONSE.UserLockedOut:
                return 'User is now blocked, too many incorrect attempts. Use "Forgot Password" link to reset your password.';
            case HTTP_RESPONSE.DisabledUser:
                return 'User is disabled.';
            case HTTP_RESPONSE.UserPasswordNotSet:
                return 'Password not created: please check your e-mail in order to configure a new password for this account.';
            case HTTP_RESPONSE.UserPasswordExpired:
                return 'Password expired: please check your e-mail in order to update password for this account.';
            case HTTP_RESPONSE.UserNotAuthorized:
                return 'User not authorized to login.';
        }
        return 'Error code: ' + data.response;
    }

    async login() {
        if (this.loading == true)
            return;

        this.loading = true;
        try {
            let response:any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/auth/Login'),
                data: {
                    Username: this.username,
                    Password: this.password
                },
                withCredentials: true,
                responseType: 'json'
            });
            this.loading = false;
            this.loginIsActive = false;

            if (response.data.response == HTTP_RESPONSE.LoggedIn) {
                await General.AuthenticateUser(response, this.$route, this.$router) 
            } else if(response.data.response == HTTP_RESPONSE.TwoFactorRequired) {
                this.loginIsActive = true;
                this.openOtpModal();
            } else {
                this.$fire({
                    text: this.getMessage(response.data) ,
                    type: "error"
                });
                this.loginIsActive = true;
            }
        } catch (error) {
            this.loading = false;
            this.loginIsActive = true;
            General.showAlertDanger(error, this);
        }

    }

    openOtpModal() {
        this.$bvModal.show('otpLoginModal');
    }

    openForgotPasswordModal() {
        this.$bvModal.show('forgotPasswordModal');
    }

    onForgotPasswordRequestSuccess() {
        this.$bvModal.hide('forgotPasswordModal');
    }

    onResetPasswordSuccess() {
        this.$bvModal.hide('resetPasswordModal');
    }
}
